export var LAYOUT_SOURCE = {
  OLX: 'olx',
  OLX_AUTOS: 'olxAutos',
  VALUATION_FLOW: 'valuationFlow',
  BUYER_INTENT: 'buyerIntent',
  SELL_THEMATIC_PAGE: 'sellThematicPage'
};
export default LAYOUT_SOURCE;